import React, { useState } from 'react';
import { KeenIcon } from '@/components';
import { ContentLoader } from '@/components/loaders';
import { DeleteConfirmModal } from '@/components/DeleteConfirmModal';

const Table = ({
  // Data props
  data = [],
  loading = false,
  
  // Configuration props
  type = 'reference-data',
  columns = [
    { key: 'priority', label: 'Priority (max 5)', type: 'checkbox' },
    { key: 'date', label: 'Date Create', type: 'text' },
    { key: 'content', label: 'Content', type: 'text' },
    { key: 'source', label: 'Source', type: 'text' }
  ],
  
  // Callback functions
  onEdit,
  onDelete,
  onPriorityChange,
  
  // Customization props
  className = '',
  emptyMessage = 'No data available',
  deleteConfirmMessage = 'Bạn có chắc chắn muốn xóa item này không?'
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Event handlers
  const handleEdit = (item) => {
    if (onEdit) onEdit(item);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteConfirm(true);
  };

  const handlePriorityChange = (item) => {
    if (onPriorityChange) onPriorityChange(item);
  };

  const confirmDelete = () => {
    if (onDelete && selectedItem) onDelete(selectedItem);
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const cancelAction = () => {
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  // Render cell content based on column type
  const renderCell = (item, column) => {
    switch (column.type) {
      case 'checkbox':
        return (
          <input
            type="checkbox"
            checked={item[column.key]}
            onChange={() => handlePriorityChange(item)}
            className="cursor-pointer"
          />
        );
      case 'text':
        return item[column.key];
      case 'custom':
        return column.render ? column.render(item) : null;
      default:
        return item[column.key];
    }
  };

  return (
    <>
      <div className={`overflow-x-auto border rounded relative min-h-[200px] flex items-center justify-center ${className}`}>
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <ContentLoader />
          </div>
        ) : data.length === 0 ? (
          <div className="text-gray-500">{emptyMessage}</div>
        ) : (
          <table className="min-w-full text-sm">
            <thead>
              <tr className="bg-gray-50">
                {columns.map((column) => (
                  <th
                    key={column.key}
                    className="px-2 py-2 font-medium text-left"
                    style={column.width ? { width: column.width, minWidth: column.width, maxWidth: column.width } : {}}
                  >
                    {column.label}
                  </th>
                ))}
                <th
                  className="px-2 py-2 font-medium text-center"
                  style={{ width: '10%', minWidth: '10%', maxWidth: '10%' }}
                ></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id} className="border-t hover:bg-gray-50 transition-colors">
                  {columns.map((column) => (
                    <td
                      key={column.key}
                      className="px-2 py-2"
                      style={column.width ? { width: column.width, minWidth: column.width, maxWidth: column.width } : {}}
                    >
                      {renderCell(item, column)}
                    </td>
                  ))}
                  <td
                    className="px-2 py-2 flex gap-2 pl-9"
                    style={{ width: '10%', minWidth: '10%', maxWidth: '10%' }}
                  >
                    {onEdit && (
                      <button
                        className="text-gray-500 hover:text-blue-600 transition-colors"
                        onClick={() => handleEdit(item)}
                      >
                        <KeenIcon icon="pencil" />
                      </button>
                    )}
                    {onDelete && (
                      <button
                        className="text-gray-500 hover:text-red-600 transition-colors"
                        onClick={() => handleDelete(item)}
                      >
                        <KeenIcon icon="trash" />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        show={showDeleteConfirm}
        message={deleteConfirmMessage}
        onConfirm={confirmDelete}
        onCancel={cancelAction}
      />
    </>
  );
};

export { Table }; 